import { connect } from 'react-redux';

import Notification, { NotificationProps } from '../components/Notification';
import { BannerProps } from '@built/design-system';
import { StoreState } from '../types';
import { getAuthError, getUserError } from '../reducers';

export default connect(mapStateToProps)(Notification);

function mapStateToProps(
  state: StoreState,
  ownProps?: BannerProps
): Pick<NotificationProps, 'content'> {
  if (ownProps && ownProps.children) {
    return { content: ownProps.children };
  }

  const authError = getAuthError(state);
  const userError = getUserError(state);

  let messages: string[] = [];

  if (userError) {
    messages.push(`Error updating user: ${userError}`);
  }

  if (authError) {
    messages.push(`Error authenticating: ${authError.message}`);
  }

  return { content: messages.join('\n') };
}



// WEBPACK FOOTER //
// ./src/containers/Notification.tsx